"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var LikeReactionButton_1 = __importDefault(require("./styles/LikeReactionButton"));
var LikeReactionContainer_1 = __importDefault(require("./styles/LikeReactionContainer"));
var assets_1 = require("../../assets");
var hiddenEmojis = [
    {
        id: 'dark',
        image: jsx_runtime_1.jsx(assets_1.SkinToneDarkSvg, {}, void 0),
        alt: 'Emoji Thumb up 6',
    },
    {
        id: 'medium-dark',
        image: jsx_runtime_1.jsx(assets_1.SkinToneMediumDarkSvg, {}, void 0),
        alt: 'Emoji Thumb up 5',
    },
    {
        id: 'medium',
        image: jsx_runtime_1.jsx(assets_1.SkinToneMediumSvg, {}, void 0),
        alt: 'Emoji Thumb up 4',
    },
    {
        id: 'medium-light',
        image: jsx_runtime_1.jsx(assets_1.SkinToneMediumLightSvg, {}, void 0),
        alt: 'Emoji Thumb up 3',
    },
    {
        id: 'light',
        image: jsx_runtime_1.jsx(assets_1.SkinToneLightSvg, {}, void 0),
        alt: 'Emoji Thumb up 2',
    },
    {
        id: 'yellow',
        image: jsx_runtime_1.jsx(assets_1.SkinToneYellowSvg, {}, void 0),
        alt: 'Emoji Thumb up 1',
        defaultSelected: true,
    },
];
var LikeReaction = function (_a) {
    var onClickReaction = _a.onClickReaction, onDoubleClick = _a.onDoubleClick, backgroundColor = _a.backgroundColor, isActive = _a.isActive, isEditPage = _a.isEditPage;
    var containerRef = react_1.useRef(null);
    var _b = react_1.useState('rgba(0,0,0,0.08)'), backgroundColorRGBA = _b[0], setBackgroundColorRGBA = _b[1];
    var _c = react_1.useState(false), reactionToolbarOpen = _c[0], setReactionToolbarOpen = _c[1];
    var isSharePage = !!document.querySelector('div.PageContainer-v3mi3-0') && window.location.href.includes('/share/');
    var handleReactionClick = react_1.useCallback(function (e) {
        var _a;
        if (isEditPage)
            return;
        var container = containerRef.current;
        if (!reactionToolbarOpen && !isActive) {
            setReactionToolbarOpen(true);
            return;
        }
        var lastButton = container === null || container === void 0 ? void 0 : container.querySelector('button.activeThumbUp');
        var currentButton = e.target.closest('button');
        if (isActive) {
            var defaultButton = container === null || container === void 0 ? void 0 : container.querySelector('button.default');
            lastButton === null || lastButton === void 0 ? void 0 : lastButton.classList.remove('activeThumbUp');
            defaultButton === null || defaultButton === void 0 ? void 0 : defaultButton.classList.add('activeThumbUp');
            setReactionToolbarOpen(false);
        }
        else {
            lastButton === null || lastButton === void 0 ? void 0 : lastButton.classList.remove('activeThumbUp');
            currentButton.classList.add('activeThumbUp');
        }
        var skinTone = e.target.id;
        if (!isActive && isSharePage)
            localStorage.setItem('thumbUpId', ((_a = document === null || document === void 0 ? void 0 : document.querySelector('button.activeThumbUp')) === null || _a === void 0 ? void 0 : _a.id) || '');
        onClickReaction(e, skinTone);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isActive, onClickReaction, reactionToolbarOpen, isSharePage]);
    react_1.useEffect(function () {
        var container = containerRef.current;
        if (reactionToolbarOpen) {
            container === null || container === void 0 ? void 0 : container.classList.add('activeThumbUp');
        }
        else {
            container === null || container === void 0 ? void 0 : container.classList.remove('activeThumbUp');
        }
    }, [reactionToolbarOpen]);
    var emojisRender = react_1.useMemo(function () {
        return hiddenEmojis.map(function (_a) {
            var id = _a.id, image = _a.image, alt = _a.alt, defaultSelected = _a.defaultSelected;
            return (jsx_runtime_1.jsx(LikeReactionButton_1.default, __assign({ id: id, onClick: handleReactionClick, onDoubleClick: onDoubleClick, className: defaultSelected ? 'default activeThumbUp' : '' }, { children: image }), id));
        });
    }, [handleReactionClick, onDoubleClick]);
    react_1.useEffect(function () {
        var opacity = isActive ? 1 : '0.08';
        var rColor = +parseInt(backgroundColor.substring(1, 3), 16);
        var gColor = +parseInt(backgroundColor.substring(3, 5), 16);
        var bColor = +parseInt(backgroundColor.substring(5, 7), 16);
        var finalColor = "rgba(" + rColor + "," + gColor + "," + bColor + "," + opacity + ")";
        setBackgroundColorRGBA(finalColor);
    }, [backgroundColor, isActive]);
    return (jsx_runtime_1.jsx(LikeReactionContainer_1.default, __assign({ id: "reactions-container", ref: containerRef, backgroundColorRGBA: backgroundColorRGBA, isActive: isActive, onDoubleClick: onDoubleClick, onMouseLeave: function () { return setReactionToolbarOpen(false); } }, { children: emojisRender }), void 0));
};
exports.default = LikeReaction;
